import React, { useState } from 'react';
import { Image, AlertTriangle } from 'lucide-react';

interface ImageWithStatusProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}

const ImageWithStatus: React.FC<ImageWithStatusProps> = ({ src, alt, className, onClick }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const handleLoad = () => {
    setIsLoading(false);
  };

  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  return (
    <div className={`relative ${className || ''}`} onClick={onClick}>
      {isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-200 rounded-lg">
          <Image className="w-8 h-8 text-gray-400 animate-pulse" />
        </div>
      )}
      {hasError && !isLoading && (
        <div className="absolute inset-0 flex items-center justify-center bg-red-100 rounded-lg">
          <AlertTriangle className="w-8 h-8 text-red-500" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-cover rounded-lg border ${
          isLoading || hasError ? 'opacity-0' : 'opacity-100'
        }`}
        onLoad={handleLoad}
        onError={handleError}
      />
    </div>
  );
};

export default ImageWithStatus;
